import { BonusReportForPlaceTranslations } from "./bonus-report-for-place-pt-br";

export const BONUS_REPORT_FOR_PLACE_EN_US: BonusReportForPlaceTranslations = {
	title: "Bonus",
};
